import { useFormContext } from 'react-hook-form'
import { DatabaseResourceSelector } from '@/components/form/database-resource-selector'
import type { CreateDatabaseFormValues } from '@/routes/databases/create-database/form/schema'

export const Resource = () => {
  const { watch } = useFormContext<CreateDatabaseFormValues>()
  const type = watch('type')

  return <DatabaseResourceSelector type={type} />
}
